<template>
  <div class="main">
    <el-button type="primary" @click="addShow" class="addBtn"
      >发布招工</el-button
    >
    <el-select v-model="auditStatus" placeholder="岗位状态">
      <el-option
        v-for="item in auditOptions"
        :key="item.value"
        :label="item.label"
        :value="item.value"
      >
      </el-option>
    </el-select>
    <el-input
      placeholder="岗位描述关键词"
      v-model="description"
      class="searchInput"
    ></el-input>
    <treeCascader class="searchInput" :value="work_area" @change="areaChange" />
    <el-input
      placeholder="发布人"
      v-model="contact"
      class="searchInput"
    ></el-input>
    <el-button type="primary" @click="search" class="searchBtn">搜索</el-button>
    <el-button type="primary" @click="clear" class="resetBtn">重置</el-button>

    <el-table
      ref="multipleTable"
      :data="tableData"
      tooltip-effect="dark"
      :highlight-current-row="false"
      class="dataTable"
      border
    >
      <el-table-column
        prop="id"
        label="ID"
        align="center"
      ></el-table-column>
      <el-table-column prop="work_type" label="工作类型" width="300">
        <template slot-scope="scope">
          <div class="workType__list">
            <div
              class="workType__item"
              v-for="item in scope.row.work_type"
              :key="item.id"
            >
              <el-tag>{{ item.name }}</el-tag>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="description"
        label="岗位描述"
        width="228"
        :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column
        prop="address"
        label="工作地点"
        width="228"
        :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column prop="address" label="人数" align="center">
        <template slot-scope="scope">
          {{ scope.row.staff_num.name ? scope.row.staff_num.name : "-" }}
        </template>
      </el-table-column>
      <el-table-column
        prop="low_salary"
        label="工资"
        align="center"
        width="110"
      >
        <template slot-scope="scope">
          {{ scope.row.low_salary ? scope.row.low_salary + "元" : "-" }}
        </template>
      </el-table-column>
      <el-table-column
        prop="salary_type"
        label="工资类型"
        align="center"
        width="80"
      >
        <template slot-scope="scope">
          {{ scope.row.salary_type | formateSalaryType(salaryType) }}
        </template>
      </el-table-column>
      <el-table-column
        prop="contact"
        label="发布人"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="phone"
        label="联系电话"
        align="center"
        width="112"
      ></el-table-column>
      <el-table-column
        prop="update_time"
        label="发布时间"
        align="center"
        width="163"
      ></el-table-column>
      <el-table-column
        prop="status_msg"
        label="发布状态"
        width="110"
        align="center"
        :show-overflow-tooltip="true"
      >
      </el-table-column>
      <el-table-column
        prop="click_num"
        label="被查看人次"
        align="center"
        width="100"
      ></el-table-column>
      <el-table-column
        prop="contact_num"
        label="被联系人次"
        align="center"
        width="100"
      >
        <template slot-scope="scope">
          {{ scope.row.contact_num ? scope.row.contact_num : 0 }}
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="操作" width="158" align="center">
        <template slot-scope="scope">
          <el-button
            type="text"
            size="small"
            v-if="scope.row.audit_status == 2"
            @click="showDetail(scope.row)"
            >详情</el-button
          >
          <el-button type="text" size="small" @click="toEdit(scope.row)"
            >修改</el-button
          >
          <el-button
            type="text"
            size="small"
            v-if="scope.row.status && scope.row.audit_status == 2"
            @click="republicFn(scope.row)"
            >重新发布</el-button
          >
          <el-button
            type="text"
            size="small"
            v-if="!scope.row.status && scope.row.audit_status == 2"
            @click="deleteFn(scope.row)"
            >关闭</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      :current-page="currentPage"
      :page-size="pageSize"
      layout="total, prev, pager, next, jumper"
      :total="total"
      @current-change="handleCurrentChange"
    />

    <el-drawer
      title="详情"
      :visible.sync="drawerShow"
      direction="rtl"
      :size="400"
      class="detailDrawer"
    >
      <iframe :src="detailUrl" frameborder="0" class="detailIframe"></iframe>
    </el-drawer>
  </div>
</template>

<script>
import { RECRUIT_HOST } from "../../../constants/apiHosts";
import treeCascader from "./components/treeCascader.vue";

export default {
  components: { treeCascader },
  data() {
    return {
      auditOptions: [
        {
          label: "正在招",
          value: 1,
        },
        {
          label: "已招满",
          value: 2,
        },
        {
          label: "待审核",
          value: 3,
        },
        {
          label: "审核未通过",
          value: 4,
        },
      ],
      auditStatus: "",
      description: "",
      work_area: "",
      contact: "",
      tableData: [],
      pageSize: 10,
      currentPage: 1,
      total: 1,
      salaryType: [
        {
          value: 1,
          name: "元/天",
        },
        {
          value: 2,
          name: "元/月",
        },
        {
          value: 3,
          name: "元/平",
        },
        {
          value: 0,
          name: "面议",
        },
      ],
      detailUrl: "",
      drawerShow: false,
    };
  },
  filters: {
    formateSalaryType(salary_type, salaryType) {
      let item = salaryType.find((x) => x.value == salary_type);
      if (item) {
        return item.name;
      } else {
        return "-";
      }
    },
  },
  created() {
    this.getJobList();
  },
  mounted() {},
  methods: {
    areaChange(val) {
      this.work_area = val;
    },
    search() {
      this.currentPage = 1;
      this.getJobList();
    },
    clear() {
      this.auditStatus = "";
      this.description = "";
      this.work_area = "";
      this.contact = "";

      this.currentPage = 1;
      this.getJobList();
    },
    getJobList() {
      this.$axios
        .get(
          `${RECRUIT_HOST}/oddjobs/recruit/mylist?page=${this.currentPage}&size=${this.pageSize}&status=${this.auditStatus}&contact=${this.contact}&description=${this.description}&work_area=${this.work_area}`
        )
        .then((res) => {
          if (res.data.code == 0) {
            this.tableData = res.data.data.data;
            this.total = res.data.data.total;
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getJobList();
    },
    addShow() {
      this.$router.push({
        path: "/tools/job/add",
      });
    },
    showDetail(row) {
      this.detailUrl = `https://static.${
        window.location.href.indexOf("topnews.cn") >= 0 || window.location.href.indexOf("topnews.cn") >= 0
          ? "topnews.cn"
          : "dingnews.net"
      }/recruit-h5/index.html#/pages/jobHunt/detail?id=${row.id}&preview=1`;
      this.drawerShow = true;
    },
    toEdit(row) {
      this.$router.push({
        path: "/tools/job/add",
        query: {
          id: row.id,
        },
      });
    },
    republicFn(row) {
      this.$confirm("此操作将重新发布该数据，是否继续？", "重新发布", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$axios
            .post(`${RECRUIT_HOST}/admin/oddjobsRecruit/checkStatus`, {
              id: row.id,
            })
            .then((res) => {
              if (res.data.code == 0) {
                this.getJobList();

                this.$message({
                  type: "success",
                  message: "重新发布成功!",
                });
              } else {
                this.$message.error(res.data.msg);
              }
            });
        })
        .catch((error) => {
          console.log(error);
        });
    },
    deleteFn(row) {
      this.$confirm("此操作将关闭该数据，是否继续？", "关闭", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$axios
            .post(`${RECRUIT_HOST}/admin/oddjobsRecruit/checkStatus`, {
              id: row.id,
            })
            .then((res) => {
              if (res.data.code == 0) {
                this.getJobList();

                this.$message({
                  type: "success",
                  message: "关闭成功!",
                });
              } else {
                this.$message.error(res.data.msg);
              }
            });
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.main {
  border-radius: 8px;
  background: #ffffff;
  padding: 12px 32px 100px 32px;

  .el-select {
    width: 186px;
    margin: 0 25px 0 0;
    border-radius: 2px;
    height: 36px;

    /deep/.el-input__inner {
      height: 36px;
      background-color: #f2f3f5;
      border: 0;
      color: #333333;
      font-size: 14px;
      font-weight: 400;
      font-family: "PingFang SC";
    }
  }

  .searchInput {
    width: 186px;
    margin: 20px 25px 0 0;
    border-radius: 2px;
    height: 36px;

    /deep/.el-input__inner {
      height: 36px;
      background-color: #f2f3f5;
      border: 0;
      color: #333333;
      font-size: 14px;
      font-weight: 400;
      font-family: "PingFang SC";
    }
  }

  .el-button {
    height: 36px;
    line-height: 20px;
    padding-top: 8px;
  }

  .resetBtn {
    border: 1px solid #999999;
    background-color: #ffffff;
    color: #666666;
    margin-top: 20px;
  }

  .addBtn {
    width: 112px;
    margin-right: 90px;
  }

  /deep/.dataTable {
    margin-top: 24px;
    color: #4e5969;
    font-size: 14px;
    font-weight: 400;
    font-family: "PingFang SC";
    line-height: 20px;

    th {
      background-color: #f2f4f5;
      color: #1d2129;
      font-weight: bold;
    }

    .workType__list {
      display: flex;
      flex-wrap: wrap;

      .workType__item {
        margin: 5px 8px 5px 0;
      }
    }

    td:last-child .cell {
      display: flex;
      align-items: center;

      .el-button {
        margin: 0 10px 0 0;
        color: #165dff;
      }
    }
  }

  .el-pagination {
    float: right;
    margin: 20px 0 0 0;
  }

  .detailDrawer {
    /deep/.el-drawer__header {
      margin-bottom: 20px;
    }

    .detailIframe {
      width: 370px;
      height: calc(100vh - 100px);
      margin: 0 15px;
    }
  }
}
</style>
